import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { FormBuilder, FormGroup, AbstractControl, Validators } from '@angular/forms';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Location } from '@angular/common';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { removeObjArray, pushObjArray, pushStringArray } from 'src/app/services/convert.service';
import { DataService } from 'src/app/services/data.service';
import { Observable } from 'rxjs';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { AddAnswerExerciseBookClubComponent } from '../add-answer-exercise-book-club/add-answer-exercise-book-club.component';
import { AddExerciseBookClubComponent } from '../add-exercise-book-club/add-exercise-book-club.component';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';

@Component({
  selector: 'app-exercise-book-club',
  templateUrl: './exercise-book-club.component.html',
  styleUrls: ['./exercise-book-club.component.scss']
})
export class ExerciseBookClubComponent implements OnInit {
  tabs: any = [{ path: '/book-club/exercise', label: 'Exercise' },];
  TITLE = "General Knowledge"

  BOOK_KEY: any;
  EXERCISE_LIST: any[];

  QUESTION_LIST: any[];
  form: FormGroup;
  name: AbstractControl;
  grammar: AbstractControl;
  instruction: AbstractControl;
  defaultInstruction: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;

  SKILL_OBJ: any;
  SELECTED_SOUND_FILE: any;
  START_UPLOAD = false;
  uploadPercentSound: Observable<number>;

  BOOK: any;
  typeKey: any;
  backLink: any;
  constructor(private router: Router
    , private route: ActivatedRoute
    , public resource: ResourceStore
    , private fb: FormBuilder
    , private dialog: MatDialog
    , public store: BookstoreStore
    , private location: Location
    , private auth: AuthStore
    , private ds: DataService
    , private snackBar: MatSnackBar
    , private storage: FireStorageService
  ) { }

  goBack() {
    this.router.navigate([this.backLink])
  }

  ngOnInit() {
    this.form = this.fb.group({
      name: [null, Validators.required],
    })
    this.route.params.subscribe(async params => {
      const { id, typeKey } = params;
      this.typeKey = `${typeKey}` === '0' ? false : true;
      this.backLink = this.typeKey === false ? `/audio-reading/library` : `/book-store/books/submitted`;
      this.BOOK_KEY = id;
      this.BOOK = await this.store.fetchBook(this.BOOK_KEY);
      if (!this.BOOK) {
        this.QUESTION_LIST = [];
        this.goBack()
        return;
      }
      this.form.patchValue({ name: this.BOOK.exerciseTip, })
      this.store.fetchReadingExercise(this.BOOK_KEY, docs => {
        this.QUESTION_LIST = docs;
      })
    })
  }


  async onSave(f: any, isBack: boolean) {
    if (this.form.valid) {
      this.processClose = isBack ? true : false;
      this.processNew = !isBack;
      this.form.disable();
      const { name } = f;
      this.BOOK.exerciseTip = name;
      this.store.saveBook(this.BOOK, (success, res) => {
        if (success) {
          this.snackBar.open("Book has been saved successful.", "Done", { duration: 1000 });
          this.processClose = false;
          this.processNew = false;
          if (isBack) {
            this.location.back()
          }
          else {
            this.router.navigate([this.backLink])
          }
          this.form.enable();
        }
      })


    }
  }


  delete(question) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'delete', name: question.name, title: 'Delete Question' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        const questions = this.BOOK.questions || null;
        const QUESTION_DATA = removeObjArray(questions, question.key)
        this.BOOK.questions = QUESTION_DATA;
        this.store.saveBook(this.BOOK, (success, res) => {
          this.snackBar.open("Question has been removed successful.", "Done", { duration: 1000 });
        })
      }
    })
  }

  deleteAnswer(question, answer) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'delete', name: question.name, title: 'Delete Answer' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        const answerAfterRemove = removeObjArray(question.answers || [], answer.key);
        question.answers = answerAfterRemove;
        const { questions } = this.BOOK;
        const questionsData = pushObjArray(questions, question)
        this.BOOK.questions = questionsData;
        this.store.saveBook(this.BOOK, (success, res) => {
          this.snackBar.open("Answer has been removed successful.", "Done", { duration: 1000 });
        })
      }
    })
  }


  addNewLine(item: any) {
    let dialogRef = this.dialog.open(AddExerciseBookClubComponent, {
      data: {
        FORM: this.form.value,
        BOOK: this.BOOK,
        QUESTION: item || null,
      },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }


  createQuiz(item, question) {
    let dialogRef = this.dialog.open(AddAnswerExerciseBookClubComponent, {
      data: {
        FORM: this.form.value,
        BOOK: this.BOOK,
        QUESTION: item,
        ANSWER: question || null,
      },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }


}
